import {
  Heading,
  Avatar,
  Box,
  Center,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';


export default function Card1({ user }) {
  return (
    <Center py={6} display='inline-block' m={6}>
      <Box
        // maxW={'300px'}
        w={'300px'}
        h={'250px'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'}
        rounded={'lg'}
        // py={6}
        // px={4}
        m={6}
        textAlign={'center'}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
      >
        <Avatar
          size={'xl'}
          src={user.image === undefined ? '' : require(`./images/Coordinators/${user.image}.webp`)}
          alt={'Avatar Alt'}
          mb={4}
          pos={'relative'}
          _after={{
            content: '""',
            w: 4,
            h: 4,
            bg: 'green.300',
            border: '2px solid white',
            rounded: 'full',
            pos: 'absolute',
            bottom: 0,
            right: 3,
          }}
        />
        <Heading fontSize={'2xl'} fontFamily={'body'}>
          {user.name}
        </Heading>
        <br />
        <Text fontWeight={600} color={'gray.500'} mb={4}>
          {user.contact}
        </Text>
        {/* <Text
          textAlign={'center'}
          color={useColorModeValue('gray.700', 'gray.400')}
          px={3}>
          {user.course}
        </Text> */}
        {/* <Text
          textAlign={'center'}
          color={useColorModeValue('gray.700', 'gray.400')}
          px={3}>
          {user.email===undefined?'':user.email}
        </Text> */}
      </Box>
    </Center>
  );
}